import { WEEKDAYS } from '@energybox/react-ui-library/dist/utils';

export const weekdayToNumberArray = (weekdaysArray: string[]) => {
  return weekdaysArray.map(weekday => WEEKDAYS[weekday]);
};
